export const listSubscriptionsForCustomer = `
   query listCustomerSubscriptionsForCustomer($limit: Int, $nextToken: String) {
       listCustomerSubscriptionsForCustomer(limit: $limit, nextToken: $nextToken) {
           items {
              id
              customerId
              status
              created
              customer {
                name
              }
              items {
                items {
                  id
                  subscriptionId
                  priceId
                  price {
                    id
                    amount
                    billingPeriod
                    product {
                        id
                        name
                    }
                  }
                  quantity
                }
                nextToken
              }
           }
         nextToken  
       }
   }
`;


export const getSubscription = `
   query getCustomerSubscription($id:ID!) {
       getCustomerSubscription(id:$id) {
            id
            customerId
            status
            items {
                items {
                    id
                    priceId
                    quantity
                }
            }
            customer {
                id
                name
            }   
       } 
}`;

export const listProducts = `
   query listProducts($filter: ProductsFilterInput) {
       listProducts(filter: $filter) {
           items {
              id
              name
              shortDescription
              longDescription
              status
              freeTrial
              baseFee
              prices {
                items {
                  id
                  amount
                  billingPeriod
                  stripePriceId
                  pricingModel
                }
                nextToken
              }
           }
         nextToken  
       }
   }
`;

export const getProduct = `
   query getProduct($id: ID!) {
       getProduct(id: $id) {
           id
           name
           shortDescription
           longDescription
           status
           freeTrial
           baseFee
           prices {
             items {
               id
               amount
               billingPeriod
               stripePriceId
               pricingModel
             }
             nextToken
           }
           lineItems {
             items {
               productFeature {
                 name
                 description
               }
             }
             nextToken
           }
       }
   }
`;



